import type { CreateSessionPayload } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/sessions/sessions'
import { createSession } from 'redux/redux-modules'
import { put } from 'redux-saga/effects'

export function* createSessionSaga(args: { matchedVolunteerId: string; parentRequestId: string }) {
  const { matchedVolunteerId, parentRequestId } = args

  const createSessionPayload: CreateSessionPayload = {
    matched_volunteer_id: matchedVolunteerId,
    parent_request_id: parentRequestId,
  }

  yield put(createSession.actions.makeRequest({ payload: createSessionPayload }))
}
